import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueSweetalert2 from 'vue-sweetalert2';
import VueMask from 'v-mask'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueYoutube from 'vue-youtube'

import vco from "v-click-outside"

import router from './router'
import store from '@/state/store'
import i18n from './i18n'
import utils from './utils'

import './registerServiceWorker';
import "@/assets/scss/app.scss";

import { initFirebaseBackend } from './helpers/firebase/authUtils';

import { configureFakeBackend } from './helpers/fakebackend/fake-backend';

import Pusher from 'pusher-js';
import Cookie from 'js-cookie';

console.log('PUSHER_HOST: ' + process.env.VUE_APP_PUSHER_HOST);
console.log('PUSHER_FORCETLS: ' + process.env.VUE_APP_PUSHER_FORCETLS);
console.log('PUSHER_ENCRYPTED: ' + process.env.VUE_APP_PUSHER_ENCRYPTED);

// Função para obter o token de autenticação
function getAuthToken() {
  // Primeiro tenta ler do cookie
  let token = Cookie.get('_easyindustria_token');
  
  // Se não encontrar no cookie, tenta ler do localStorage como fallback
  if (!token) {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    token = user.token;
  }
  
  return token;
}

// Configurar authorizer para canais privados
const authorizer = (channel, options) => {
  // #region agent log
  const logData = {
    location: 'main.js:46',
    message: 'Authorizer chamado pelo Pusher',
    data: {
      channelName: channel.name,
      isPrivate: channel.name.startsWith('private-'),
      options,
    },
    timestamp: Date.now(),
    sessionId: 'debug-session',
    runId: 'run1',
    hypothesisId: 'H1,H2',
  };
  console.log('DEBUG: Authorizer chamado pelo Pusher', logData.data);
  fetch('http://127.0.0.1:7242/ingest/efaaa223-ca27-4eaa-9af0-280336e09eb8', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(logData),
  }).catch(() => {});
  // #endregion
  
  return {
    authorize: (socketId, callback) => {
      const token = getAuthToken();
      // A rota de autorização está em /api/broadcasting/auth (não /broadcasting/auth)
      const API_URL = process.env.VUE_APP_BASEURI || window.location.origin;
      const authUrl = `${API_URL}/api/broadcasting/auth`;
      
      // #region agent log
      const authLogData = {
        location: 'main.js:56',
        message: 'Autorizando canal privado',
        data: {
          channel: channel.name,
          socketId,
          hasToken: !!token,
          tokenPreview: token ? token.substring(0, 20) + '...' : 'null',
          apiUrl: authUrl,
          baseUri: process.env.VUE_APP_BASEURI,
          windowOrigin: window.location.origin,
        },
        timestamp: Date.now(),
        sessionId: 'debug-session',
        runId: 'run1',
        hypothesisId: 'H1,H3,H4',
      };
      console.log('DEBUG: Autorizando canal privado', authLogData.data);
      fetch('http://127.0.0.1:7242/ingest/efaaa223-ca27-4eaa-9af0-280336e09eb8', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(authLogData),
      }).catch(() => {});
      // #endregion

      fetch(authUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': token ? `Bearer ${token}` : '',
        },
        body: JSON.stringify({
          socket_id: socketId,
          channel_name: channel.name,
        }),
      })
      .then(response => {
        // #region agent log
        console.log('DEBUG: Resposta da autorização', {
          channel: channel.name,
          status: response.status,
          statusText: response.statusText,
        });
        // #endregion

        if (!response.ok) {
          throw new Error(`Authorization failed: ${response.status} ${response.statusText}`);
        }
        return response.json();
      })
      .then(data => {
        // #region agent log
        console.log('DEBUG: Autorização bem-sucedida', {
          channel: channel.name,
          data,
        });
        // #endregion
        callback(null, data);
      })
      .catch(error => {
        // #region agent log
        console.error('DEBUG: Erro na autorização', {
          channel: channel.name,
          error: error.message,
        });
        // #endregion
        callback(error, null);
      });
    },
  };
};

// #region agent log
console.log('DEBUG: Configurando Pusher', {
  pusherKey: process.env.VUE_APP_PUSHER_KEY ? 'present' : 'missing',
  pusherHost: process.env.VUE_APP_PUSHER_HOST,
  pusherPort: process.env.VUE_APP_PUSHER_PORT,
  hasAuthorizer: typeof authorizer === 'function',
  baseUri: process.env.VUE_APP_BASEURI,
  windowOrigin: window.location.origin,
});
// #endregion

// #region agent log
const pusherConfigLogData = {
  location: 'main.js:161',
  message: 'Configurando Pusher antes da instanciação',
  data: {
    pusherKey: process.env.VUE_APP_PUSHER_KEY ? 'present' : 'missing',
    pusherHost: process.env.VUE_APP_PUSHER_HOST,
    pusherPort: process.env.VUE_APP_PUSHER_PORT,
    pusherCluster: process.env.VUE_APP_PUSHER_CLUSTER,
    pusherForceTLS: process.env.VUE_APP_PUSHER_FORCETLS,
    pusherEncrypted: process.env.VUE_APP_PUSHER_ENCRYPTED,
    hasAuthorizer: typeof authorizer === 'function',
  },
  timestamp: Date.now(),
  sessionId: 'debug-session',
  runId: 'run1',
  hypothesisId: 'H1,H2',
};
console.log('DEBUG: Configurando Pusher antes da instanciação', pusherConfigLogData.data);
fetch('http://127.0.0.1:7242/ingest/efaaa223-ca27-4eaa-9af0-280336e09eb8', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(pusherConfigLogData),
}).catch(() => {});
// #endregion

window.pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
  cluster: process.env.VUE_APP_PUSHER_CLUSTER,
  wsHost: process.env.VUE_APP_PUSHER_HOST, // Ajustado para localhost conforme solicitado
  wsPort: process.env.VUE_APP_PUSHER_PORT,
  wssPort: (process.env.VUE_APP_PUSHER_FORCETLS) ?? process.env.VUE_APP_PUSHER_PORT,
  forceTLS: process.env.VUE_APP_PUSHER_FORCETLS,
  encrypted: process.env.VUE_APP_PUSHER_ENCRYPTED,
  disableStats: true,
  enabledTransports: ['ws', 'wss'],
  authorizer: authorizer, // Usar apenas authorizer para Laravel WebSockets
  channelAuthorizer: authorizer, // Também definir channelAuthorizer para compatibilidade
});

// #region agent log
const pusherInstancedLogData = {
  location: 'main.js:173',
  message: 'Pusher instanciado',
  data: {
    pusherState: window.pusher.connection.state,
    socketId: window.pusher.connection.socket_id,
    config: {
      hasAuthorizer: !!window.pusher.config?.authorizer,
      authorizerType: typeof window.pusher.config?.authorizer,
      hasChannelAuthorizer: !!window.pusher.config?.channelAuthorizer,
      channelAuthorizerType: typeof window.pusher.config?.channelAuthorizer,
      configKeys: window.pusher.config ? Object.keys(window.pusher.config) : [],
    },
    // Verificar se o authorizer está disponível diretamente
    directAuthorizer: typeof authorizer,
    hasDirectAuthorizer: typeof authorizer === 'function',
  },
  timestamp: Date.now(),
  sessionId: 'debug-session',
  runId: 'run1',
  hypothesisId: 'H1,H2',
};
console.log('DEBUG: Pusher instanciado', pusherInstancedLogData.data);
fetch('http://127.0.0.1:7242/ingest/efaaa223-ca27-4eaa-9af0-280336e09eb8', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(pusherInstancedLogData),
}).catch(() => {});

// Se o authorizer não estiver no config após a instanciação, tentar defini-lo
if (!window.pusher.config?.authorizer && !window.pusher.config?.channelAuthorizer && typeof authorizer === 'function') {
  console.warn('DEBUG: Authorizer não encontrado no config após instanciação. Tentando definir...');
  if (window.pusher.config) {
    window.pusher.config.authorizer = authorizer;
    window.pusher.config.channelAuthorizer = authorizer;
    console.log('DEBUG: Authorizer e channelAuthorizer definidos no config manualmente');
  }
} else if (window.pusher.config?.channelAuthorizer && !window.pusher.config?.authorizer) {
  // Se channelAuthorizer estiver disponível mas authorizer não, copiar
  window.pusher.config.authorizer = window.pusher.config.channelAuthorizer;
  console.log('DEBUG: Authorizer copiado de channelAuthorizer');
}
// #endregion

// Adicionar listeners para rastrear conexão e autorização
window.pusher.connection.bind('connected', () => {
  // #region agent log
  const connectedLogData = {
    location: 'main.js:185',
    message: 'Pusher conectado',
    data: {
      socketId: window.pusher.connection.socket_id,
      state: window.pusher.connection.state,
    },
    timestamp: Date.now(),
    sessionId: 'debug-session',
    runId: 'run1',
    hypothesisId: 'H1,H5',
  };
  console.log('DEBUG: Pusher conectado', connectedLogData.data);
  fetch('http://127.0.0.1:7242/ingest/efaaa223-ca27-4eaa-9af0-280336e09eb8', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(connectedLogData),
  }).catch(() => {});
  // #endregion
});

window.pusher.connection.bind('error', (err) => {
  // #region agent log
  const errorLogData = {
    location: 'main.js:269',
    message: 'Erro na conexão Pusher',
    data: {
      error: err,
      errorType: err?.type,
      errorData: err?.data,
      errorMessage: err?.error?.message || err?.message || String(err),
      state: window.pusher.connection.state,
      socketId: window.pusher.connection.socket_id,
      wsHost: process.env.VUE_APP_PUSHER_HOST,
      wsPort: process.env.VUE_APP_PUSHER_PORT,
      wsUrl: `ws://${process.env.VUE_APP_PUSHER_HOST}:${process.env.VUE_APP_PUSHER_PORT}`,
    },
    timestamp: Date.now(),
    sessionId: 'debug-session',
    runId: 'run1',
    hypothesisId: 'H1,H2,H5',
  };
  console.error('DEBUG: Erro na conexão Pusher', errorLogData.data);
  fetch('http://127.0.0.1:7242/ingest/efaaa223-ca27-4eaa-9af0-280336e09eb8', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(errorLogData),
  }).catch(() => {});
  // #endregion
});

window.pusher.connection.bind('state_change', (states) => {
  // #region agent log
  const stateChangeLogData = {
    location: 'main.js:215',
    message: 'Estado do Pusher mudou',
    data: {
      previous: states.previous,
      current: states.current,
      socketId: window.pusher.connection.socket_id,
      wsHost: process.env.VUE_APP_PUSHER_HOST,
      wsPort: process.env.VUE_APP_PUSHER_PORT,
      // Verificar se o servidor WebSocket está acessível quando muda para unavailable
      isUnavailable: states.current === 'unavailable',
      wasConnecting: states.previous === 'connecting',
    },
    timestamp: Date.now(),
    sessionId: 'debug-session',
    runId: 'run1',
    hypothesisId: 'H1,H2,H5',
  };
  console.log('DEBUG: Estado do Pusher mudou', stateChangeLogData.data);
  
  // Se mudou para unavailable após tentar conectar, tentar verificar se o servidor está acessível
  if (states.current === 'unavailable' && states.previous === 'connecting') {
    // #region agent log
    const unavailableLogData = {
      location: 'main.js:215',
      message: 'Pusher mudou para unavailable após connecting',
      data: {
        wsHost: process.env.VUE_APP_PUSHER_HOST,
        wsPort: process.env.VUE_APP_PUSHER_PORT,
        wsUrl: `ws://${process.env.VUE_APP_PUSHER_HOST}:${process.env.VUE_APP_PUSHER_PORT}`,
        suggestion: 'Verifique se o servidor WebSocket está rodando',
      },
      timestamp: Date.now(),
      sessionId: 'debug-session',
      runId: 'run1',
      hypothesisId: 'H2',
    };
    console.error('DEBUG: Pusher mudou para unavailable após connecting', unavailableLogData.data);
    fetch('http://127.0.0.1:7242/ingest/efaaa223-ca27-4eaa-9af0-280336e09eb8', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(unavailableLogData),
    }).catch(() => {});
    // #endregion
  }
  
  fetch('http://127.0.0.1:7242/ingest/efaaa223-ca27-4eaa-9af0-280336e09eb8', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(stateChangeLogData),
  }).catch(() => {});
  // #endregion
});

// Interceptar subscribe para verificar se o authorizer é chamado
const originalSubscribe = window.pusher.subscribe.bind(window.pusher);
window.pusher.subscribe = function(channelName) {
  // #region agent log
  const subscribeLogData = {
    location: 'main.js:272',
    message: 'Pusher.subscribe() chamado',
    data: {
      channelName,
      isPrivate: channelName.startsWith('private-'),
      hasAuthorizer: !!this.config?.authorizer,
      authorizerType: typeof this.config?.authorizer,
      hasChannelAuthorizer: !!this.config?.channelAuthorizer,
      channelAuthorizerType: typeof this.config?.channelAuthorizer,
      configKeys: this.config ? Object.keys(this.config) : [],
      pusherConfig: {
        hasAuthorizer: !!window.pusher.config?.authorizer,
        authorizerType: typeof window.pusher.config?.authorizer,
        hasChannelAuthorizer: !!window.pusher.config?.channelAuthorizer,
        channelAuthorizerType: typeof window.pusher.config?.channelAuthorizer,
        configKeys: window.pusher.config ? Object.keys(window.pusher.config) : [],
      },
      // Verificar se o authorizer está disponível diretamente
      directAuthorizer: typeof authorizer,
      hasDirectAuthorizer: typeof authorizer === 'function',
    },
    timestamp: Date.now(),
    sessionId: 'debug-session',
    runId: 'run1',
    hypothesisId: 'H1,H2',
  };
  console.log('DEBUG: Pusher.subscribe() chamado', subscribeLogData.data);
  fetch('http://127.0.0.1:7242/ingest/efaaa223-ca27-4eaa-9af0-280336e09eb8', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(subscribeLogData),
  }).catch(() => {});
  // #endregion
  
  // Se o authorizer não estiver disponível no config, mas estiver disponível diretamente, 
  // garantir que o Pusher tenha acesso a ele
  if (channelName.startsWith('private-') && !this.config?.authorizer && !this.config?.channelAuthorizer && typeof authorizer === 'function') {
    // #region agent log
    console.warn('DEBUG: Authorizer não encontrado no config, mas disponível diretamente. Tentando corrigir...', {
      channelName,
      hasConfigAuthorizer: !!this.config?.authorizer,
      hasConfigChannelAuthorizer: !!this.config?.channelAuthorizer,
      hasDirectAuthorizer: typeof authorizer === 'function',
    });
    // #endregion
    // Tentar definir o authorizer no config se possível
    if (this.config) {
      this.config.authorizer = authorizer;
      this.config.channelAuthorizer = authorizer;
    }
  } else if (channelName.startsWith('private-') && this.config?.channelAuthorizer && !this.config?.authorizer) {
    // Se channelAuthorizer estiver disponível mas authorizer não, copiar
    this.config.authorizer = this.config.channelAuthorizer;
    // #region agent log
    console.log('DEBUG: Authorizer copiado de channelAuthorizer para subscribe', {
      channelName,
    });
    // #endregion
  }
  
  const channel = originalSubscribe(channelName);
  
  // #region agent log
  console.log('DEBUG: Canal retornado por subscribe()', {
    channelName,
    channelState: channel.state,
    channelSubscribed: channel.subscribed,
  });
  // #endregion
  
  // Adicionar listeners para rastrear eventos do canal
  if (channelName.startsWith('private-')) {
    channel.bind('pusher:subscription_succeeded', () => {
      // #region agent log
      console.log('DEBUG: Canal privado autorizado com sucesso', {
        channelName,
      });
      // #endregion
    });
    
    channel.bind('pusher:subscription_error', (status) => {
      // #region agent log
      console.error('DEBUG: Erro ao autorizar canal privado', {
        channelName,
        status,
        errorType: status.type,
        errorData: status.data,
      });
      // #endregion
    });
  }
  
  return channel;
};

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}

Vue.config.productionTip = false
Vue.use(VueYoutube)
Vue.use(BootstrapVue)
Vue.use(vco)
Vue.use(Vuelidate)
Vue.use(VueSweetalert2);
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.use(utils)
Vue.component('apexchart', VueApexCharts)


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
